
import { createContext, useReducer } from "react";
import EnvoieReducer from "./EnvoieReducer";

const INITIAL_STATE = {
    envois: [],
    count: 1,
    isFetching: false,
    error: false,
    envoie: {},
    isFetchingAdd: false,
    errorAdd: false,
    envoieUpdate: {},
    isFetchingUpdate: false,
    errorUpdate: false,
    isFetchingGet: false,
    errorGet: false,
    cost: "",
    isFetchingSimulate: false,
    errorSimulate: false,
    histories: [],
    isFetchingHistories: false,
    errorHistories: false,
};


export const EnvoieContext = createContext(INITIAL_STATE);

export const EnvoieContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(EnvoieReducer, INITIAL_STATE);
    
    return (
      <EnvoieContext.Provider
        value={{
          envois: state.envois,
          count: state.count,
          isFetching: state.isFetching,
          error: state.error,
          envoie: state.envoie,
          isFetchingAdd: state.isFetchingAdd,
          errorAdd: state.errorAdd,
          envoieUpdate: state.envoieUpdate,
          isFetchingUpdate: state.isFetchingUpdate,
          errorUpdate: state.errorUpdate,
          isFetchingGet: state.isFetchingGet,
          errorGet: state.errorGet,
          cost: state.cost,
          isFetchingSimulate: state.isFetchingSimulate,
          errorSimulate: state.errorSimulate,
          histories: state.histories,
          isFetchingHistories: state.isFetchingHistories,
          errorHistories: state.errorHistories,
          dispatch,
        }}
      >
        {children}
      </EnvoieContext.Provider>
    );
  };